import { render } from "./SupervisorNav.vue?vue&type=template&id=537aeb7e&scoped=true"
import script from "./SupervisorNav.vue?vue&type=script&lang=js"
export * from "./SupervisorNav.vue?vue&type=script&lang=js"

import "./SupervisorNav.vue?vue&type=style&index=0&id=537aeb7e&scoped=true&lang=css"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537aeb7e"]])

export default __exports__